import React from 'react';
import Admin from './Admin';
import { Navigate } from 'react-router-dom';

const AdminRoutes = {
	root: {
		tag: 'admin',
		path: '/admin',
		auth: true,
		component: <Navigate to="/admin/investors" replace />,
	},
	dashboard: {
		tag: 'admin_dashboard',
		path: '/admin/dashboard',
		auth: true,
		component: <Navigate to="/admin/investors" replace />,
	},
	investors_list: {
		tag: 'admin_investors_list',
		path: '/admin/investors',
		auth: true,
		component: <Admin page="investors" />,
	},
	document_access: {
		tag: 'admin_document_access_logs',
		path: '/admin/document_access_logs',
		auth: true,
		component: <Admin page="document_access_logs" />,
	},
	document_access_capital_calls: {
		tag: 'admin_document_access_capital_calls',
		path: '/admin/document_access_capital_calls',
		auth: true,
		component: <Admin page="document_access_capital_calls" />,
	},
	email_notifications: {
		tag: 'admin_email_notifications',
		path: '/admin/email_notifications',
		auth: true,
		component: <Admin page="email_notifications" />,
	},
	document_email_notifications: {
		tag: 'admin_document_email_notifications',
		path: '/admin/document_email_notifications',
		auth: true,
		component: <Admin page="document_email_notifications" />,
	},
	user_email_notifications: {
		tag: 'admin_user_email_notifications',
		path: '/admin/user_email_notifications',
		auth: true,
		component: <Admin page="user_email_notifications" />,
	},
	notification_monitoring: {
		tag: 'admin_notification_monitoring',
		path: '/admin/notification_monitoring',
		auth: true,
		component: <Admin page="notification_monitoring" />,
	},
};

export default AdminRoutes;
